import TransactionsHistory from './TransactionsHistory';
import TransactionView from './TransactionView';
import TableBody from './TableBody';
import RunTransferAction from './RunTransferAction';
import Notes from './Notes';
import ExternalProfileLinks from './ExternalProfileLinks';
import AccountExternalLinks from './AccountExternalLinks';
import * as ra from './ra';

export default {
  TransactionsHistory,
  TransactionView,
  TableBody,
  RunTransferAction,
  Notes,
  ExternalProfileLinks,
  AccountExternalLinks,
  ra,
  AppBar: {
    TEST: 'Test environment',
    DEMO: 'Demo environment',
    PRODUCTION: 'Production',
    licenseMissing: 'License is missing',
    licenseNotActive: 'License has expired',
    openEndUsersActivity: 'Open End-users Activity',
    LinkToProfile: {
      INDIVIDUAL: 'Individual',
      BUSINESS: 'Business',
      EMPLOYEE: 'Business team member',
      PARTNER: 'Partner',
      DEAL: 'Deal',
      HEAD_TRANSACTION: 'Head transaction',
      EVENT: 'Event',
      API_IDENTITY: 'Authentication identity',
      REPORT: 'Report',
      back: 'Back',
      INDIVIDUAL_UUID: 'Individual UUID',
      BUSINESS_UUID: 'Business UUID',
      EMPLOYEE_UUID: 'Business team member UUID',
      PARTNER_UUID: 'Partner UUID',
      DEAL_UUID: 'Deal UUID',
      HEAD_TRANSACTION_UUID: 'Head transaction UUID',
      EVENT_UUID: 'Event UUID',
      API_IDENTITY_UUID: 'Authentication identity UUID',
      REPORT_UUID: 'Report UUID',
      go: 'Go',
      openObject: 'Open object by UUID',
      incorrectLink: 'Please remove all spaces.',
    },
    licenseWillExpire: 'Your license will expire on %{date}.',
    licenseExpiredMessage:
      'Your license has expired on %{date}. The system works in limited mode. Please contact your supplier to obtain new license.',
    licenseMissingMessage:
      'License is missing. The system works in limited mode. Please contact your supplier to obtain the license.',
  },
  address: {
    _: 'Address',
    country: 'Country',
    addressLine: 'Address line',
    city: 'City',
    cityLocalized: 'City localized',
    postalCode: 'Postal code',
    region: 'Region',
    suburb: 'Suburb',
    building: 'Building',
    geolocation: 'Geolocation',
    type: 'Type',
    latitude: 'Latitude',
    longitude: 'Longitude',
    note: 'Note',
  },
  BackgroundTask: {
    downloadCSV: 'Download CSV',
    downloadExcel: 'Download Excel file',
    downloadPDF: 'Download PDF',
    invoice: 'Invoice',
    INITIAL: 'Initial',
    IN_PROGRESS: 'In progress',
    DONE: 'Done',
    DONE_export: 'Export ready',
    DONE_import: 'Import ready',
    DONE_export_limited: 'Export ready (limited to %{maxRecordsNumber})',
    FAILED: 'Failed',
    loading: 'Loading',
    downloadWillStartLimited:
      'Only the first %{maxRecordsNumber} records were exported. Your download will start automatically.',
    downloadWillStart: 'Your download will start automatically',
    downloadTheResult: 'You can download the result',
    recordsAndErrors: 'Records: %{records}, errors: %{errors}.',
    solutionId: 'Solution',
    file: 'File',
    confirmationExportTitle: 'Export limit: %{maxRecordsNumber} records',
    confirmationExportBody:
      'You can export up to %{maxRecordsNumber} records at a time. For faster results, narrow your filters. For complex or very large exports, please use Veengu Analytics DB. If the export reaches %{maxRecordsNumber} records, it will stop and finalize automatically.',
  },
  ProfileLimits: {
    _: 'Profile limits',
    ownProfileLimits: 'Own profile limits',
    empty: 'There are no profile-wide limits yet.',
    outOf: 'out of',
    viewOwn: 'View Own',
    activePackages: 'Active Limit Packages',
    closedPackages: 'Closed Limit Packages',
    shared: 'SHARED',
    owner: 'Owner',
    attention: 'Attention!',
    alert: 'Please confirm the closing of the account(s) and indicate the reason.',
    reason: 'Reason',
  },
  BlockOrUnblockProfile: {
    attention: 'Attention!',
    alert: 'Please confirm the blocking of the profile and indicate the reason',
    reason: 'Reason',
    profileStatusUpdated: 'Profile status updated',
  },
  ApiIdentity: {
    identificationData: 'Identification data',
    name: 'Name',
    username: 'Username',
    email: 'Email',
    phone: 'Phone',
    status: 'Status',
    secretWord: 'Secret word',
    apiKey: 'Api Key',
    apiKeyPrefix: 'Api Key Prefix',
    createdAt: 'Created At',
    password: 'Password',
    reset: 'Reset',
    valueTrue: 'Defined',
    valueFalse: 'Not defined',
    clearSecretWordWarning: `Resetting the user's Secret Word will delete the existing Secret Word to confirm actions in the Wallet App. Be sure that the user identity check is passed correctly. The user will require to define a new Secret Word after successful login. Are you sure you want to continue?`,
    //
    activeIdentityLocks: 'Active identity locks',
    addLock: 'Add lock',
    startDatetime: 'Start datetime',
    endDatetime: 'End datetime',
    reason: 'Reason',
    actor: 'Actor',
    outOf: 'out of',
    viewIdentityLock: 'View identity lock',
    officer: 'Officer',
    addIdentityLock: 'Add identity lock',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    deleteLock: 'Delete lock',
    deleteIdentityLock: 'Delete identity lock',
    delete: 'Delete',
    reasonToRemoveLock: 'Reason to remove lock',
    system: 'System',
    timeLeft: 'Time left',
    wrongAttemptsTooltip: 'The number of attempts before the user access is locked permanently.',
    //
    authenticationMethods: 'Authentication methods',
    devices: 'Devices',
    staticPassword: 'Static password',
    login: 'Login',
    otpBySms: 'OTP by SMS',
    wrongAttempts: 'Wrong attempts',
    wrongResetAttempts: 'Wrong reset attempts',
    otpByEmail: 'OTP by Email',
    clearEmail: 'Reset email',
    clearEmailWarning:
      "Resetting the identity's email will delete the existing email address used for login and password recovery. Be sure that the user identity check is passed correctly. Are you sure you want to continue?",
    clearPassword: 'Reset password',
    clearPasswordWarning:
      "Resetting the identity's username will delete the existing username and password used for login and password recovery. Be sure that the user identity check is passed correctly. Are you sure you want to continue?",
    unlinkProfile: 'Unlink profile',
    unlinkProfileWarning:
      'Are you sure you would like to unlink this profile? This action is irreversible.',
    resetSecretWord: 'Reset secret word',
    resetAttemptsCounter: 'Clear attempts counter',
    clearResetAttemptsCounter: 'Clear reset attempts counter',
    resetAttemptsCounterWarning:
      "You are going to reset the unsuccessful authentication attempt counter. This will allow user to make new authentication attempts and potentially weaken the system's security. Please confirm the counter reset.",
    osName: 'OS name',
    osVersion: 'OS version',
    pushToken: 'Push token',
    enrolledAt: 'Enrolled at',
    deviceLabel: 'Device label',
    applicationId: 'Application ID',
    vendorId: 'Vendor ID',
    noDevices: 'There are no devices yet.',
    activate: 'Activate',
    revoke: 'Revoke',
    Filters: {
      KeyboardDateTimePicker: {
        from: 'From',
        to: 'To',
      },
    },
    authKeys: 'Authentication keys',
    authKeyId: 'ID',
    authKeyTag: 'Tag',
    authKeyStatus: 'Status',
  },
  ImportButton: 'Import',
  MetricField: {
    outOf: 'out of',
  },
  OperationTypeChangelog: {
    INSERT: 'Created',
    UPDATE: 'Updated',
    DELETE: 'Deleted',
    IMPORT: 'Registered',
    viewApprovalCase: 'View approval case',
    requestedOn: {
      INSERT: 'Create requested on %{date}',
      UPDATE: 'Update requested on %{date}',
      DELETE: 'Delete requested on %{date}',
      IMPORT: 'Register requested on %{date}',
    },
    approvedOn: 'Approved on %{date}',
  },
  RecordTitle: {
    prev: 'prev',
    next: 'next',
    version: 'Version as of',
    changelogWarning: 'You are viewing an old version of this profile. ',
    draftWarning: 'You are viewing your non-submitted draft. ',
    editLockWarning: 'You are viewing your submitted draft. ',
    current: 'current version',
    history: 'View history',
    view: 'View the ',
    lastUpdated: 'Last updated on %{date} %{time}. ',
    lastUpdatedBy: 'Last updated on %{date} %{time} by %{by}. ',
    loading: 'Loading...',
    createdOn: 'created on',
    viewDraft: 'VIEW MY DRAFT',
    viewCase: 'VIEW CASE',
    haveDraft: 'You have a draft of this object',
    proposeChange: 'Propose a change to this object',
    draftWillBeCreated: 'A draft will be created',
    submittedDraft: 'Your draft is pending review',
    lockEditTitle: 'Changes are pending review',
    lockEditDescription: 'This object cannot be edited at this time',
    submitted: 'Submitted',
    created: 'Created',
    myDraft: 'My draft',
    discard: 'Discard',
    submit: 'Submit',
    discardConfirmationTitle: 'Discard draft',
    discardConfirmationBody: 'Do you want to discard your draft?',
    submitConfirmationTitle: 'Submit draft',
    submitConfirmationBody: 'Do you want to submit your draft?',
  },
  EditSourceName: {
    editNameAndAlias: 'Edit name & alias',
    editAccountNameAndAlias: 'Edit account name & alias',
    editAlias: 'Edit alias',
    editAccountAlias: 'Edit account alias',
    name: 'Name',
    alias: 'Alias',
  },
  Originator: {
    _: 'Originator',
  },
  LinkToAccount: {
    goToAccount: 'GO TO ACCOUNT',
  },
  AffiliatedObjects: {
    affiliatedObjects: 'Affiliated objects',
    noAffiliatedObjects: 'There are no Affiliated Objects.',
    addAffiliatedObject: 'Add Affiliated Object',
    viewAll: 'View all',
    viewAllAffiliatedObjects: 'View all Affiliated Objects',
    affiliationType: 'Affiliation type',
    createdAt: 'Created at',
    deletedAt: 'Archived at',
    archive: 'Archive',
    archivedAffiliatedObjects: 'Archived Affiliated Objects',
    objectType: 'Object type',
    subObjectType: 'Sub-object type',
    objectUUID: 'Object UUID',
    subObjectUUID: 'Sub-object UUID',
    SHARED_WITH: 'Shared with',
    INVITED_BY: 'Invited by',
    COMMISSION_PAY_TO: 'Commission pay to',
    CLONED_FROM: 'Copied from',
    REWARD_EVENT: 'Reward event',
    ACTIVITY_EVENT: 'Activity event',
    COMMISSION_PAY_FOR: 'Commission pay for',
    REFUNDED_TRANSACTION: 'Refunded transaction',
    REFUND_TRANSACTION: 'Refund transaction',
    EARNINGS_PARENT: 'Transaction Earnings Parent',
    INDIVIDUAL: 'Individual',
    BUSINESS: 'Business',
    EMPLOYEE: 'Team member',
    PARTNER: 'Partner',
    ACCOUNT: 'Account',
    accountUUIDOrNumber: 'Account UUID or number',
    accountNotFound:
      'The account cannot be found using the provided UUID or number. Please enter a valid and existing account UUID or number.',
    warning:
      'The object cannot be found using the provided UUID. Please enter a valid and existing UUID.',
    earningsParentDuplicateCurrency:
      'A Transaction Earnings Parent link already exists for this currency. Only one link per currency is allowed.',
  },
  AccountOwner: {
    owner: 'Owner',
  },
  SelectInput: {
    any: 'Any',
  },
  AddFilterButton: {
    label: 'Add filter',
  },
  ProfileTags: {
    profileTags: 'Profile tags',
    edit: 'Edit',
    noTagsYet: 'There are no profile tags yet.',
    noTagsToAdd: 'There are no profile tags to add.',
    addProfileTags: 'Add profile tags',
    editProfileTags: 'Edit profile tags',
    profileTagsTooltip:
      'Profile tags serve for profiling purposes, aiding in the classification of profiles and facilitating pricing table selection. Optionally, they can be populated into the transaction context, enabling "forked" fee application based on the transaction tag mechanism.',
  },
  ApiIdentityAside: {
    identity: 'Identity',
    identities: 'Identities',
  },
  EventTask: {
    eventTasks: 'Event tasks',
    action: 'Action',
    reason: 'Reason',
    taskType: 'Task type',
    taskState: 'Task state',
    manualAction: 'Manual action',
    runManualAction: 'Run manual action',
    empty: 'There are no event tasks yet.',
    run: 'Run',
    noAvailableActions: 'No available actions',
  },
  ApiIdentityLink: {
    apiIdentity: 'API Identity',
  },
  AccountWithErrorWarning: {
    attention: 'Attention!',
    alert: 'Please confirm the error reset action and submit your comment',
    comment: 'Comment',
    warning: 'Warning: Error found on this account',
    cancel: 'Cancel',
    confirm: 'Confirm',
    errorResetSuccess: 'Error is cleared successfully!',
  },
  ProcessingFlowSelect: {
    processingFlow: 'Processing flow',
  },
  UpdateRiskRating: {
    riskRating: 'Risk rating',
    note: 'Note',
    LOW: 'Low',
    MEDIUM: 'Medium',
    HIGH: 'High',
    updateRiskRating: 'Update risk rating',
    profileRiskRatingUpdated: 'Profile risk rating updated',
  },
  UpdateCustomerNumber: {
    customerNumber: 'Customer number',
    note: 'Note',
    updateCustomerNumber: 'Update customer number',
    profileCustomerNumberUpdated: 'Customer number updated',
    warning:
      'Changing the customer number is a sensitive operation. This number is used in reports, exports, and integrations with external systems.',
  },
  ApprovalRequiredDialog: {
    title: 'Approval Required',
    message: 'Your changes have been submitted for approval.',
    viewCase: 'View Approval Case',
    close: 'Close',
  },
  Applications: {
    label: 'Applications',
    drawer: {
      heading: 'Application details',
      stagesData: 'Stages data',
      internalData: 'Internal data',
      raw: 'Raw response',
    },
    columns: {
      id: 'ID',
      processType: 'Process type',
      processName: 'Process name',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
      currentStages: 'Current stage(s)',
      status: 'Status',
    },
    filters: {
      createdFrom: 'Created from',
      createdTo: 'Created to',
      status: 'Status',
      IN_PROGRESS: 'In progress',
      COMPLETED: 'Completed',
      TERMINATED: 'Terminated',
    },
    actions: {
      attention: 'Attention!',
      terminate: 'Terminate',
      terminateConfirm: 'Please confirm the termination of the application and indicate the reason',
      reason: 'Reason',
    },
    notifications: {
      terminated: 'Application terminated',
      terminateFailed: 'Failed to terminate application',
    },
  },
};
